import { FC } from 'react';
import { AnalyticsLineChart } from 'shared/ui/Analytics/AnalyticsLineChart';
import { LineChartData } from 'shared/ui/Analytics/types';
import { getRenamedLineChartData } from '../../../lib/getRenamedLineChartData';

interface ObjectFavoritesChartProps {
  pointsData: LineChartData[];
  minWidth: number;
}

const chartLines = [
  { key: 'line', label: 'Добавление в избранное', color: '#FF8C00' },
];

export const ObjectFavoritesChart: FC<ObjectFavoritesChartProps> = ({
  pointsData,
  minWidth,
}) => {
  const renamedPointsData = getRenamedLineChartData(pointsData, chartLines);

  return (
    <AnalyticsLineChart
      data={renamedPointsData}
      lineLabels={chartLines.map((l) => l.label)}
      lineColors={chartLines.map((l) => l.color)}
      height={200}
      minWidth={minWidth}
    />
  );
};
